import { IFiltroAtendimentosVistorias } from "../../../Interfaces/VistoriaEntregaChaves/ListarAtendimentosVistorias/ListarAtendimentosVistoriasInterfaces";
import { ListarAtendimentosVistoriasService } from "../../../Services/VistoriaEntregaChaves/ListarAtendimentosVistorias/ListarAtendimentosVistoriasServices";
import { Controller } from "../../Controller";

export async function ListarAtendimentosVistoriasController(
    pagina: number,
    SEG_ATENDIMENTOS: "GERAL" | "USUARIO" | "GRUPO" | "ACOMPANHAMENTO",
    filtro: IFiltroAtendimentosVistorias
) {
    return Controller(
        ListarAtendimentosVistoriasService(
            pagina,
            SEG_ATENDIMENTOS,
            filtro,
            false
        )
    );
}

export async function ListarAtendimentosVistoriasTransferirController(
    SEG_ATENDIMENTOS: "GERAL" | "USUARIO" | "GRUPO" | "ACOMPANHAMENTO",
    filtro: IFiltroAtendimentosVistorias
) {
    return Controller(
        ListarAtendimentosVistoriasService(0, SEG_ATENDIMENTOS, filtro, true)
    );
}
